// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"681":"a0449822","745":"297dbaa1","754":"dd460631","968":"7cea343d"}[chunkId] + ".css";
};